export const ID_PREFIX = { MEDIA_ASSET: "med_mediaasset_" } as const;
